module.exports = __webpack_public_path__ + "static/media/null.f6be71db.png";